// frontend/src/utils/countries.js

export const COUNTRY_OPTIONS = [
  { code: "US", name: "United States" },
  { code: "CA", name: "Canada" },
  { code: "GB", name: "United Kingdom" },
  { code: "KR", name: "South Korea" },

  // Keep the rest of your existing options here.
];